import { Content } from "@/ui/Content";
import * as simplePagesAdditionalComponents from "@/components/SimplePage";
import * as popularRolesAdditionalComponents from "@/components/PopularRolesPage";
import * as landingPagesAdditionalComponents from "@/components/LandingPage";
import { getSimplePagesStaticProps } from "@/functions/getSimplePagesStaticProps";
import { getPopularRolesStaticProps } from "@/functions/getPopularRolesStaticProps";
import { getLandingPagesStaticProps } from "@/functions/getLandingPagesStaticProps";
import { pages_helper } from "@/helpers/pages_helper";
import { popular_roles_helper } from "@/helpers/popular_roles_helper";
import { landing_pages_helper } from "@/helpers/landing_pages_helper";

export default function SimpleOrPopularRolesPage({ content }) {
  return (
    <Content
      items={content}
      additionalComponents={{ ...simplePagesAdditionalComponents, ...popularRolesAdditionalComponents, ...landingPagesAdditionalComponents }}
    />
  );
}

export async function getStaticProps({ params: { url_slugs } }) {
  const [url_slug] = url_slugs;

  if (popular_roles_helper.find(url_slug)) {
    return getPopularRolesStaticProps(url_slug);
  }
  
  if (landing_pages_helper.find(url_slug)) {
    return getLandingPagesStaticProps(url_slug);
  }

  return getSimplePagesStaticProps(url_slugs);
}

export async function getStaticPaths() {
  return {
    paths: [
      ...pages_helper.toNestedPaths(),
      // These don't use nested in CMS, using this method for template purposes only
      ...popular_roles_helper.toNestedPaths(),
      ...landing_pages_helper.toNestedPaths(),
    ],
    fallback: false,
  };
}
